<script lang="ts" setup>
import { usePhoneNumberValidator } from '@shared/validation/usePhoneNumberValidator';
import { useField } from 'vee-validate';
import { computed, inject, ref } from 'vue';

import VInput from '@shared/form/VInput/VInput.vue';
import FieldRowV2 from '@shared/form/FieldRowV2/FieldRowV2.vue';
import { isDisabledInjectionKey, isReadonlyInjectionKey } from '../keys';

const { value: hasDisabledParent } = inject(isDisabledInjectionKey, { value: ref(false) });
const { value: hasReadonlyParent } = inject(isReadonlyInjectionKey, { value: ref(false) });

const validation = computed(() => usePhoneNumberValidator({ maxLength: 18 }));

const { errors, value } = useField(
  'telefoonnummer',
  computed(() => validation.value.typedSchema.value),
);

const fieldId = 'relatiegegevens-relatie-telefoonnummer';
</script>

<template>
  <FieldRowV2 :errors="errors" label="Telefoonnummer" :label-for="fieldId" v-bind="$attrs">
    <VInput
      v-if="!hasReadonlyParent"
      v-model="value"
      :has-error="!!errors.length"
      :id="fieldId"
      :is-disabled="hasDisabledParent"
      :is-readonly="hasReadonlyParent"
      type="tel"
    />
    <div v-else>{{ value ?? '-' }}</div>
  </FieldRowV2>
</template>
